import React from 'react';
import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';

interface Props {
  status: string;
}

const statusMap: Record<string, (t: any) => string> = {
  NotSent: (t) => t('status.NotSent'),
  Queued: (t) => t('status.Queued'),
  Sent: (t) => t('status.Sent'),
  Failed: (t) => t('status.Failed'),
};

const statusColorMap: Record<string, string> = {
  NotSent: 'blue',
  Queued: 'gold',
  Sent: 'green',
  Failed: 'red',
};

const OrderTennisStatusTag: React.FC<Props> = ({ status }) => {
  const { t } = useTranslation();
  const label = (statusMap[status] ? statusMap[status](t) : status) as string;
  const color = statusColorMap[status] || 'blue';

  return <Tag color={color}>{label}</Tag>;
};

export default OrderTennisStatusTag;